import {Component, OnInit, Input, ChangeDetectorRef} from '@angular/core';
import {SmartModalService} from 'app/core/services/smart-modal.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {RxComponent} from 'app/core/components/common/rx.component';
import {ConfigService} from '../../../../../core/services/config.service';
import {CertificatesService} from '../../certificates.service';
import {CustomValidator} from '../../../../../shared/utils/custom-validator.util';


declare var $;

@Component({
    selector: 'itpx-certificate-create-modal',
    templateUrl: './certificate-create-modal.component.html',
    styleUrls: ['./certificate-create-modal.component.css']
})
export class CertificateCreateModalComponent extends RxComponent implements OnInit {

    @Input() data: any = null;
    form: FormGroup
    public allowedFormats = ['pdf'];
    public maxFileSize = 3000;
    public bucket;
    readonly component: string = 'content-uploader';
    public errorNameMsg: string;
    private previousValue: number;
    public errorMsg: string;
    public guidelineLink: string = 'https://my.leapest.com/support?articleId=certificate-templates';

    constructor(
        private modalService: SmartModalService,
        private fb: FormBuilder,
        private service: CertificatesService,
        private configService: ConfigService,
        private detector: ChangeDetectorRef
    ) {
        super()
    }

    ngOnInit() {
        this.bucket = this.configService.get('aws').uploadsBucket;
        this.buildForm();

        this.form.get('agree').valueChanges
            .bindToLifecycle(this)
            .subscribe(value => {
                const validityValue = +this.form.get('validityPeriod').value;
                if (value) {
                    this.previousValue = validityValue || 1;
                    this.form.get('validityPeriod').disable({ onlySelf: true, emitEvent: false });
                    return;
                }
                if (validityValue <= 0 && this.previousValue) {
                    this.form.get('validityPeriod').setValue(this.previousValue, { onlySelf: true, emitEvent: false });
                }
                this.form.get('validityPeriod').enable({ onlySelf: true, emitEvent: false });
            });
        this.form.get('validityPeriod').valueChanges
            .bindToLifecycle(this)
            .subscribe(value => {
                if (value <= 0) {
                    this.form.get('agree').setValue(true, { onlySelf: true, emitEvent: false });
                    this.form.get('validityPeriod').disable({ onlySelf: true, emitEvent: false });
                    return;
                }
                this.previousValue = value;
            });
        this.form.get('name').valueChanges
            .bindToLifecycle(this)
            .subscribe(
                change => {
                    this.errorNameMsg = null;
                    if (!change) {
                        this.errorNameMsg = 'Template name is required';
                        return;
                    }
                   if(change && change.length > 3) {
                    this.service.certificateNameCheck(change).subscribe((res:any)=>{
                       if(res && !res.isValid)  this.form.controls.name.setErrors({ custom: { message: res.message } })
                    })
                   }
                    this.errorNameMsg = change.length < 6 ? 'Template name has to be longer than 6' : null;
                });
    }
    onCancel() {
        this.modalService.close()
    }

    onSubmit() {
        let response = this.form.getRawValue();
        this.modalService.sendResult({
            createCertificate: {
                displayName: response.name,
                s3Bucket: response.bucket,
                s3Key: response.key,
                validityPeriod: response.agree ? null : response.validityPeriod,
                fileName: response.fileName
            }
        });
    }

    public onSaved(ev) {
        this.errorMsg = null;
        const { fileName, bucket, key } = ev.data;
        this.service.validateCertificate(key, bucket).subscribe(res => {
            if (res && res.participantsNameValid) {
                this.form.patchValue({ fileName, bucket, key });
            } else {
                this.errorMsg = `Your template does not contain a placeholder for the name of the participant (participant_name), please add this placeholder to your template.`
            }
        }, err => {
            let parsedError = JSON.parse(err._body).error;
            if (parsedError.code[0] == '400') {
                this.errorMsg = parsedError.message;
            }
        })
    }

    public uploadInProgress(event) {
        if (event) {
            this.errorMsg = null;
        }
    }

    public deleteFile() {
        this.form.patchValue({ fileName: null, bucket: null, key: null });
    }

    private buildForm() {
        this.form = this.fb.group({
            name: [null, [Validators.required, Validators.minLength(5), Validators.maxLength(60)]],
            validityPeriod: [1],
            agree: [false],
            fileName: [null, [Validators.required]],
            bucket: [null, [Validators.required]],
            key: [null, [Validators.required]]
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/certificates/components/certificate-create-modal/certificate-create-modal.component.ts